import * as FC from "@fluentui/react-components";

import { DataGridProps } from "@fluentui/react-components";
import { useSearchInput } from "./search_input";
import { useCallback, useContext, useEffect, useState } from "react";
import { Context } from "../context";

/**
 * @param {DataGridProps} props
 * @param {boolean} props.noHeader
 */
export const SimpleGrid = (props) => {
    const { noHeader, onRowClick, getRowId, maxHeight, ...gridProps } = props;
    const { style: forwardedStyle, ...restGridProps } = gridProps;
    const safeGetRowId = (item) => {
        if (!item) {
            return undefined;
        }

        if (getRowId) {
            return getRowId(item);
        }

        return item?.id ?? item?.seq;
    };

    return (
        <FC.DataGrid
            {...restGridProps}
            style={forwardedStyle}
            getRowId={safeGetRowId}
        >
                {!noHeader && (
                    <FC.DataGridHeader>
                        <FC.DataGridRow>
                            {({ renderHeaderCell }, i) => (
                            <FC.DataGridHeaderCell key={i}>
                                {renderHeaderCell()}
                            </FC.DataGridHeaderCell>
                        )}
                    </FC.DataGridRow>
                </FC.DataGridHeader>
            )}
            <FC.DataGridBody>
                {({ item, rowId }) => {
                    if (!item) {
                        return null;
                    }

                    const resolvedRowId =
                        safeGetRowId(item) ??
                        rowId;

                    return (
                        <FC.DataGridRow
                            key={resolvedRowId}
                            rowId={resolvedRowId}
                            onClick={() => onRowClick && onRowClick(item)}
                        >
                            {({ renderCell }) => (
                                <FC.DataGridCell>
                                    {renderCell(item)}
                                </FC.DataGridCell>
                            )}
                        </FC.DataGridRow>
                    );
                }}
            </FC.DataGridBody>
        </FC.DataGrid>
    );
};

export const useSimpleGrid = ({ listItems, placeholder }) => {
    const { filter, SearchInput, clearSearch } = useSearchInput({ placeholder });
    const [items, setItems] = useState([]);
    const { db, apiClient } = useContext(Context);

    const refresh = useCallback(async () => {
        // Try to use apiClient first, fallback to db for backward compatibility
        const client = apiClient || db;
        const items = await listItems(client, filter);
        setItems(items);
    }, [apiClient, db, filter, listItems]);
    useEffect(() => {
        const client = apiClient || db;
        if (!client) {
            return;
        }
        refresh();
    }, [refresh]);

    return {
        refresh,
        SearchInput,
        // Clearing the filter changes `filter`, which changes `refresh`, which re-runs the effect
        // above — so an empty state's "clear" control reloads the unfiltered list on its own.
        clearSearch,
        items,
        db: apiClient || db, // Return the client being used
    };
};
